import { Anchor, Center, Group, Text, Tooltip } from '@mantine/core'
import { useParams } from 'next/navigation'
import { useTranslations } from 'next-intl'

import IconStar from '@/assets/icons/star.svg'
import { useSsrContext } from '@/contexts/ssr'
import { isUserInRestrictedRegion } from '@/i18n/country'
import type { RouteLocaleType } from '@/i18n/locales'
import { getCdcWebSignupLink } from '@/utils'
import { gotoCdcWebSignupPageOg } from '@/utils/og'

// KR compliance
const regionTradeTranslationMap: Partial<Record<RouteLocaleType, string>> = {
  'en-kr': 'Download',
  kr: '다운로드',
}

interface ActionColumnProps {
  restrictedAreas: string[]
  isOGPrice?: boolean
}

export default function ActionColumn({ restrictedAreas, isOGPrice }: ActionColumnProps) {
  const t = useTranslations()
  const { locale } = useParams<{ locale: RouteLocaleType }>()
  const { countryCode } = useSsrContext()
  const regionTradeTranslation = regionTradeTranslationMap[locale]
  const tradeTranslation = regionTradeTranslation || t('coinTable.row.trade')

  const clickLink = getCdcWebSignupLink()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation()
  }

  const handleOGClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation()
    gotoCdcWebSignupPageOg()
    return
  }

  const isRestricted = isUserInRestrictedRegion(restrictedAreas, countryCode, locale)

  return (
    <Group gap="24px" wrap="nowrap">
      <Text
        variant="subtitle-emphasis"
        c={'var(--content-active)'}
        style={{
          wordBreak: 'keep-all',
          visibility: isRestricted ? 'hidden' : 'visible',
        }}
      >
        {tradeTranslation}
      </Text>

      {!isOGPrice ? (
        <Anchor href={clickLink} onClick={handleClick} target="_blank">
          <Tooltip multiline withArrow label={t('common.addToFavorites')}>
            <Center>
              <IconStar width={16} fill="var(--content-secondary)" />
            </Center>
          </Tooltip>
        </Anchor>
      ) : (
        <Tooltip bg={'#3d3d3d'} multiline withArrow label={t('common.addToFavorites')}>
          <Center>
            <IconStar width={16} fill="var(--content-secondary)" onClick={handleOGClick} />
          </Center>
        </Tooltip>
      )}
    </Group>
  )
}
